import Fuse from 'fuse.js';

import { QuestionFilter } from '@/components/elements/questions/questions-heading.component';
import { Answer, NodeRelevance, Question, YesNoQuestion } from '@/gql/graphql';

export const initialFilterSort = (questions?: Question[]) => {
  if (!questions) return [];
  const radioQuestions = filterQuestionsByRadioType(questions);
  // we're filtering out the questions that are not relevant
  const relevant = radioQuestions.filter(
    (q) => q.relevance === NodeRelevance.Relevant || q.relevance === NodeRelevance.Pending,
  );
  // we're sorting the questions so that the ones with tailored design obligations are on top
  const sorted = relevant.sort((a, b) => {
    if (a.tailoredDesignObligations.length > 0 && b.tailoredDesignObligations.length === 0) return -1;
    if (a.tailoredDesignObligations.length === 0 && b.tailoredDesignObligations.length > 0) return 1;
    return 0;
  });
  return sorted;
};

export const filterQuestionsByFilter = (questions: YesNoQuestion[], filter: QuestionFilter) => {
  if (filter === 'ALL') {
    return questions;
  }
  if (filter === 'ANSWERED') {
    return questions.filter((question) => {
      return question.answer === 'YES' || question.answer === 'NO';
    });
  }
  if (filter === 'UNANSWERED') {
    return questions.filter((question) => {
      return question.answer === Answer.Unanswered;
    });
  }
};

export const filterQuestionsBySearch = (questions: YesNoQuestion[], search: string) => {
  const value = search;
  if (value === '') return questions;

  const fuse = new Fuse(questions, {
    includeScore: true,
    shouldSort: false,
    keys: ['question'],
    threshold: 0.3,
    ignoreLocation: true,
    includeMatches: true,
  });

  return fuse.search(value).map((r) => r.item);
};

export const filterQuestionsByRadioType = (questions: Question[]): YesNoQuestion[] => {
  return questions.filter((q: Question) => q.__typename === 'YesNoQuestion') as YesNoQuestion[];
};

export const isEveryQuestionAnswered = (questions: YesNoQuestion[]): boolean => {
  return questions.every((question) => question.answer !== Answer.Unanswered);
};

export const calculateProgress = (questions?: Question[]): number => {
  if (!questions) return 0;
  const radioQuestions = filterQuestionsByRadioType(questions);
  const relevantQuestions = radioQuestions.filter(
    (question) => question.relevance === NodeRelevance.Relevant || question.relevance === NodeRelevance.Pending,
  );

  const totalQuestions = relevantQuestions.length;
  if (totalQuestions === 0) return 0;

  const answeredQuestions = relevantQuestions.filter((question) => {
    return question.answer !== Answer.Unanswered;
  }).length;
  return Math.round((answeredQuestions / totalQuestions) * 100);
};
